// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1TpgX","gfeWrapper":"CalendarEvent_gfeWrapper__bC9dY"};